var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCentreMe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.19,38.82c0.03-15.02-12.13-27.21-27.14-27.24S72.84,23.71,72.81,38.72c-0.01,4.81,1.26,9.53,3.67,13.69l0,0L100,100 l23.56-47.58l0,0C125.95,48.29,127.21,43.59,127.19,38.82z M100,52.42c-7.51,0-13.6-6.09-13.6-13.6s6.09-13.6,13.6-13.6 c7.51,0,13.6,6.09,13.6,13.6S107.51,52.42,100,52.42z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M114.6,35.42c29.5,6.65,51.54,33.01,51.54,64.52 c0,36.53-29.61,66.14-66.14,66.14s-66.14-29.61-66.14-66.14c0-31.51,22.04-57.87,51.54-64.52"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCentreMe);
export default __webpack_public_path__ + "static/media/centre-me.441e0362c779b9eb9fffdd7299a0df61.svg";
export { ForwardRef as ReactComponent };